export class YearIndexLookUp {
    id: number;
    year: number;
    index: number;
}


// WEBPACK FOOTER //
// ./src/app/modules/validate-loss-data-submission/shared/entities/yearIndexLookUp.ts